import React, { Component } from "react";

class SiteFooter extends Component {
  render() {
    const { t } = this.props;
    return (
      <footer className="footer">
        <p>
          &copy; {new Date().getFullYear()} wodaslabs. {t("footer.rights")}
        </p>
      </footer>
    );
  }
}

export default SiteFooter;
